import { useQuery } from '@apollo/client'
import { UntitledIcon } from '@faceup/icons'
import { ulInfoCircle } from '@faceup/icons/ulInfoCircle'
import { defineMessages, FormattedMessage } from '@faceup/localization'
import { Typography } from '@faceup/ui-base'
import { ChannelPageType } from '@faceup/utils'
import { useContext } from 'react'
import { graphql } from '../../__generated__'
import { FullScreenLoader } from '../../Components/FullScreenLoader'
import { SentContent } from '../../Components/SentContent/SentContent'
import { SurveyDataContext } from '../../Contexts/SurveySourceProvider'
import { useFilledPage } from '../Survey/useFilledPage'

const messages = defineMessages('followUp.pages.surveySent', [
  { id: 'testingDescription', defaultMessage: '' },
] as const)

const query = graphql(`
  query SurveySentQuery(
    $institutionId: UUID!
    $reportSourceId: PublicReportSourceGlobalId!
  ) {
    publicInstitution(institutionId: $institutionId) {
      id
      isTesting
    }
    publicSurvey(reportSourceId: $reportSourceId) {
      id
      shortLink
      sourceType
      pages {
        ... on ChannelPage {
          id
          type
          content
          title
        }
      }
    }
  }
`)

const SurveySent = () => {
  const surveyData = useContext(SurveyDataContext)

  const { data } = useQuery(query, {
    variables: {
      institutionId: surveyData?.institution.id ?? '',
      reportSourceId: surveyData?.id ?? '',
    },
    skip: !surveyData,
  })

  const institution = data?.publicInstitution
  const survey = data?.publicSurvey

  const filledPage = useFilledPage({
    pages: survey?.pages ?? [],
    step: ChannelPageType.AfterSend,
  })

  if (!institution || !survey) {
    return <FullScreenLoader />
  }

  const title = filledPage?.title ?? null
  const description = filledPage?.content ?? null

  if (institution.isTesting) {
    return (
      <SentContent
        title={title}
        description={<FormattedMessage message={messages.testingDescription} />}
      />
    )
  }

  return (
    <SentContent title={title}>
      <div className='flex gap-2 justify-center'>
        <div>
          <UntitledIcon icon={ulInfoCircle} />
        </div>
        <Typography.Paragraph>{description}</Typography.Paragraph>
      </div>
    </SentContent>
  )
}

export default SurveySent
